import $ from 'jquery';

const $selectable_content_elements = $('.selectable-content-wrapper');

$selectable_content_elements.map((i, el) => {
  $(el).find('.content-selector').on('click', e => {
    e.preventDefault();

    const itemNumber = $(e.currentTarget).attr('data-selector-number');
    setProduct($(el), itemNumber);
  });
  $(el).find('#selectable-content__select').on('change', e => {

    const itemNumber = e.currentTarget.selectedIndex.toString();
    setProduct($(el), itemNumber);
  });
})

function setProduct(element, itemNumber) {
  element.find('.selectable-content__background').each((index, item) => {

    $(item).removeClass('selectable-content__background--active');

    if ($(item).attr('data-background-number') === itemNumber) {
      $(item).addClass('selectable-content__background--active');
    }
  });

  element.find('.selectable-content__body__item__image').each((index, item) => {
    $(item).removeClass('selectable-content__body__item__image--active');

    if ($(item).attr('data-image-number') === itemNumber) {
      $(item).addClass('selectable-content__body__item__image--active');
    }
  });

  element.find('.selectable-content__button').each((index, item) => {
    $(item).removeClass('selectable-content__button--active');

    if ($(item).attr('data-selector-number') === itemNumber) {
      $(item).addClass('selectable-content__button--active');
    }
  });

  element.find('.content-selector').each((index, item) => {
    $(item).removeClass('content-selector--active');

    if ($(item).attr('data-selector-number') === itemNumber) {
      $(item).addClass('content-selector--active');
    }
  });
}